const SCOPE_ALIAS_MAP = {
  'dashboard.view': ['system:users-management'],
  'product-setup.view': ['product-setup.manage', 'system:users-management'],
  'product-setup.create': ['product-setup.manage', 'system:users-management'],
  'product-setup.update': ['product-setup.manage', 'system:users-management'],
  'product-setup.delete': ['product-setup.manage', 'system:users-management'],
  'agents.view': ['agents.manage', 'system:users-management'],
  'agents.create': ['agents.manage', 'system:users-management'],
  'agents.update': ['agents.manage', 'system:users-management'],
  'agents.delete': ['agents.manage', 'system:users-management'],
  'branch-management.view': ['branch-management.manage', 'system:users-management'],
  'branch-management.create': ['branch-management.manage', 'system:users-management'],
  'branch-management.update': ['branch-management.manage', 'system:users-management'],
  'branch-management.delete': ['branch-management.manage', 'system:users-management'],
  'sales.view': ['sales.manage', 'system:users-management'],
  'sales.create': ['sales.manage', 'system:users-management'],
  'sales.update': ['sales.manage', 'system:users-management'],
  'sales.delete': ['sales.manage', 'system:users-management'],
  'collections.view': ['collections.manage', 'system:users-management'],
  'collections.post-payment': ['collections.manage', 'system:users-management'],
  'collections.cancel-ar': ['collections.manage', 'system:users-management'],
  'collections.remittance.view': ['collections.view', 'collections.manage', 'system:users-management'],
  'collections.remittance.create': ['collections.manage', 'system:users-management'],
  'collections.remittance.update': ['collections.manage', 'system:users-management'],
  'collections.remittance.cancel': ['collections.manage', 'system:users-management'],
  'collections.remittance.delete': ['collections.manage', 'system:users-management'],
  'commissions.view': ['commissions.manage', 'system:users-management'],
  'commissions.tag-paid': ['commissions.manage', 'system:users-management'],
  'commissions.release': ['commissions.manage', 'system:users-management'],
  'commissions.cancel': ['commissions.manage', 'system:users-management'],
  'finance.payment-requests.view': ['finance.payment-requests.manage', 'system:users-management'],
  'finance.payment-requests.create': ['finance.payment-requests.manage', 'system:users-management'],
  'finance.payment-requests.update': ['finance.payment-requests.manage', 'system:users-management'],
  'finance.liquidations.view': ['finance.liquidations.manage', 'system:users-management'],
  'finance.liquidations.create': ['finance.liquidations.manage', 'system:users-management'],
  'finance.liquidations.update': ['finance.liquidations.manage', 'system:users-management'],
  'finance.liquidations.upload': ['finance.liquidations.manage', 'system:users-management'],
  'finance.replenishments.view': ['finance.replenishments.manage', 'system:users-management'],
  'finance.replenishments.create': ['finance.replenishments.manage', 'system:users-management'],
  'reports.view': ['system:users-management'],
  'oauth-users.view': ['system:users-management'],
  'oauth-users.create': ['system:users-management'],
  'oauth-users.update': ['system:users-management'],
  'oauth-users.permissions.view': ['system:scope-management', 'system:users-management'],
  'oauth-users.permissions.update': ['system:scope-management', 'system:users-management'],
};

export function normalizeScopeList(scopes) {
  if (!Array.isArray(scopes)) {
    return [];
  }

  return Array.from(
    new Set(
      scopes
        .map((scope) => String(scope || '').trim())
        .filter((scope) => scope.length > 0)
    )
  );
}

export function grantedScopesFor(requiredScope) {
  const normalized = String(requiredScope || '').trim();
  if (!normalized) {
    return [];
  }

  return [normalized, ...(SCOPE_ALIAS_MAP[normalized] || [])];
}

export function hasScope(userScopes, requiredScope) {
  const normalizedRequired = String(requiredScope || '').trim();
  if (!normalizedRequired) {
    return true;
  }

  const normalizedUserScopes = normalizeScopeList(userScopes);
  if (normalizedUserScopes.length === 0) {
    return false;
  }

  return grantedScopesFor(normalizedRequired).some((scope) => (
    normalizedUserScopes.includes(scope)
  ));
}

export function hasAnyScope(userScopes, requiredScopes) {
  if (!Array.isArray(requiredScopes) || requiredScopes.length === 0) {
    return true;
  }

  return requiredScopes.some((scope) => hasScope(userScopes, scope));
}
